import React from "react";

import { DashboardEditorProps } from "components/ComponentType";
import InputLabelWrapper from "components/basic/input-label-wrapper/InputLabelWrapper";
import { Dropdown } from "primereact/dropdown";
import { T } from "services/lang/LanguageService";
import CommonChartEditor from "../../CommonChartEditor";
import { DatasetBarChartProps } from "../../interfaces";

function DatasetBarChartEditor({
  config,
  onConfigChange,
}: DashboardEditorProps<DatasetBarChartProps>) {
  return (
    <>
      <div className="flex flex-row gap-3 mb-3">
        <InputLabelWrapper labelName={T("label.select-x-axis-type")} col={3}>
          <Dropdown
            value={config.xAxisType ?? "date"}
            options={["category", "date"]}
            onChange={e => onConfigChange({ ...config, xAxisType: e.value, dateFormat: undefined })}
            placeholder={T("word.select-one")}
            className="p-inputtext-sm"
          />
        </InputLabelWrapper>
        {config.xAxisType === "category" && (
          <InputLabelWrapper labelName={T("component.date-format")} col={3}>
            <Dropdown
              value={config.dateFormat ?? "yyyy-MM-dd HH:mm"}
              options={["yyyy-MM-dd", "yyyy-MM-dd HH:mm:ss", "yyyy-MM-dd HH:mm"]}
              onChange={e => onConfigChange({ ...config, dateFormat: e.value })}
              placeholder={T("word.select-one")}
              editable
              className="p-inputtext-sm"
            />
          </InputLabelWrapper>
        )}
        {config.xAxisType === "date" && (
          <InputLabelWrapper labelName={T("component.date-format")} col={3}>
            <Dropdown
              value={config.dateFormat ?? "%Y-%m-%d %H:%M"}
              options={["%Y-%m-%d", "%Y-%m-%d %H:%M:%S", "%Y-%m-%d %H:%M"]}
              onChange={e => onConfigChange({ ...config, dateFormat: e.value })}
              placeholder={T("word.select-one")}
              editable
              className="p-inputtext-sm"
            />
          </InputLabelWrapper>
        )}
      </div>
      <CommonChartEditor config={config} onConfigChange={onConfigChange} />
    </>
  );
}
export default DatasetBarChartEditor;
